import React from 'react';

import Button from 'jbc-front/components/Button';
import i18n from 'i18next';

const FormSubmitBtn = ({ submitting, pristine, submit, text = i18n.t('features.RoleUsers.containers.ChangePolicyModal.change'), disabledReason, ...rest }) => (
  <Button primary disabled={submitting || pristine} onClick={submit} {...rest} disabledReason={disabledReason}>
    {text}
  </Button>
);

export default FormSubmitBtn;
